import { RouterProvider } from "react-router-dom"

/** Import direct du routeur (pas via `./routes`) pour éviter une dépendance circulaire avec le barrel qui ré-exporte NavigationApp. */
import NavigationApp from "./routes/NavigationApp";
import React from "react";
import { i18n } from "./services";
import { usePDFViewer } from "./hooks/usePDFViewer";
import IframePDFViewer from "./components/PDFViewer/IframePDFViewer";
import { ThemeProvider } from "./contexts/ThemeContext";
import { BrandingProvider } from "./contexts/BrandingContext";
import { useSharedAuthSync } from "./hooks/useSharedAuthSync";
import { getTenantName } from "./utils/brandingStyles";

function App() {
    const { isOpen, pdfUrl, openPDF, closePDF } = usePDFViewer();
    useSharedAuthSync();

    // Debug de l'état du PDFViewer
    React.useEffect(() => {
        console.log('App - État PDFViewer CHANGÉ:', { isOpen, pdfUrl });
        console.log('App - Le composant va se re-rendre avec ces props');
    }, [isOpen, pdfUrl]);

    // Exposer la fonction openPDF globalement pour l'utiliser dans HeaderLayout
    React.useEffect(() => {
        console.log('App.tsx - Exposition de la fonction openPDF globalement');
        (window as any).openPDFViewer = openPDF;
        console.log('App.tsx - Fonction exposée:', typeof (window as any).openPDFViewer);
        
        return () => {
            console.log('App.tsx - Nettoyage de la fonction globale');
            delete (window as any).openPDFViewer;
        };
    }, [openPDF]);

    // [DÉTECTION LANGUE] Détecter la langue du navigateur et initialiser i18n
    React.useEffect(() => {
        const detectAndSetLanguage = () => {
            try {
                // 1. Détecter la langue du navigateur
                const browserLang = navigator.language || navigator.languages?.[0] || 'en';
                // Convertir en format court (ex: "en-US" -> "en", "fr-FR" -> "fr", "en" -> "en")
                const detectedFromBrowser = browserLang.toLowerCase().startsWith('fr') ? 'fr' : 'en';
                
                // 2. Vérifier si une langue est déjà sauvegardée dans localStorage
                const savedLanguage = localStorage.getItem('currentLanguage');
                
                // 3. Utiliser la langue sauvegardée si elle existe, sinon utiliser la détection du navigateur
                const finalLanguage = savedLanguage || detectedFromBrowser;
                
                // 4. Appliquer la langue détectée
                i18n.changeLanguage(finalLanguage);
                if (!savedLanguage) {
                    // Sauvegarder seulement si pas déjà sauvegardée (première visite)
                    localStorage.setItem('currentLanguage', finalLanguage);
                }
            } catch (error) {
                console.error('[App] Error detecting language:', error);
                // Fallback vers anglais en cas d'erreur
                i18n.changeLanguage('en');
                localStorage.setItem('currentLanguage', 'en');
            }
        };
        
        detectAndSetLanguage();
    }, []); // Exécuter une seule fois au montage du composant

    const changeLanguage = (language: string) => {
        let updateLanguage = language === 'fr-FR' || language === 'fr' ? 'fr' : 'en';
        i18n.changeLanguage(updateLanguage);
        localStorage.setItem('currentLanguage', updateLanguage);
    };
    return (
        <ThemeProvider>
            <BrandingProvider>
                <RouterProvider router={NavigationApp} />
                <IframePDFViewer
                    pdfUrl={pdfUrl}
                    isOpen={isOpen}
                    onClose={closePDF}
                    title={`Guide d'utilisation ${getTenantName()}`}
                />
            </BrandingProvider>
        </ThemeProvider>
    )
}


export default App
